import styles from "../../styles/common/FormFieldset.module.scss"

import {ReactNode} from "react";
import clsx from "clsx";

interface FormFieldsetProps {
  extraClassName?: string;
  legendText: string;
  showLegend?: boolean;
  children: ReactNode;
}
function FormFieldset(
  {
    extraClassName,
    legendText,
    showLegend,
    children,
  }: FormFieldsetProps) {
  return (
    <div className={clsx(styles.cFormFieldset, "c-form-fieldset", extraClassName && extraClassName)}>

      <fieldset>

        <legend className={clsx(!showLegend && "c-visually-hidden")}>
          {legendText}
        </legend>


        <div className={clsx("c-form-fieldset-content")}>
          {children}
        </div>

      </fieldset>

    </div>
  );
}

export default FormFieldset;